import { render, staticRenderFns } from "./LineItemExtras.vue?vue&type=template&id=de98b5f0&"
import script from "./LineItemExtras.vue?vue&type=script&lang=js&"
export * from "./LineItemExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports